import request from '@/utils/request'; // 获取公司列表

export function getComp() {
  return request({
    url: '/ecargoaccount/user/findInsuranceCompany',
    method: 'get'
  });
} // 获取分支机构

export function queryAll(data) {
  return request({
    url: '/ecargopolicy/company/queryAll',
    method: 'get',
    params: data
  });
} // 查询当前登录用户信息

export function getInfo(data) {
  return request({
    url: '/ecargoaccount/userInfo/findUser',
    method: 'get',
    params: data
  });
} // 获取证件类型

export function getData() {
  return request({
    url: '/commondictionary/dictionary/queryByCodeType',
    method: 'post',
    data: {
      "codeType": "UserIdCard"
    }
  });
} // 获取相关码表对应的数据

export function getDataCodeAndName(data) {
  return request({
    url: '/commondictionary/dictionary/queryByCodeType',
    method: 'post',
    data: data
  });
} // 提交资料

export function editInfo(data) {
  return request({
    url: '/ecargoaccount/userInfo/updateUser',
    method: 'post',
    data: data
  });
} // 删除授信行

export function deleteLine(data) {
  return request({
    url: '/ecargoaccount/userInfo/delete',
    method: 'post',
    data: data
  });
} // 单行授信

export function CreditOne(data) {
  return request({
    url: '/ecargoaccount/userInfo/CreditOne',
    method: 'post',
    data: data
  });
} // 查询当前登录保险公司信息

export function getInsuranceCompanyInfo(data) {
  return request({
    url: '/ecargoaccount/userInfo/findInsuranceCompanyUser',
    method: 'get',
    params: data
  });
} // 查询当前登录保险公司信息

export function editUserInfo(data) {
  return request({
    url: '/ecargoaccount/insurance/updatePassWord',
    method: 'post',
    data: data
  });
}